import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import identity from 'lodash/identity';
import { connect, useSelector } from 'react-redux';

import { actionCreators } from 'react/api/actions/routeDivisionModal';
import { getResourceTo } from 'react/utils/utils';

import Modal from 'react/components/Modal';
import RouteDivisionGridFooter from 'react/containers/modals/RouteDivision/RouteDivisionGridFooter';
import RouteDivisionForm from 'react/containers/modals/RouteDivision/RouteDivisionForm';
import RouteDivisionGrid from 'react/containers/modals/RouteDivision/RouteDivisionGrid';

function RouteDivisionModal(props) {
  const isOpen = useSelector((state) => state.routeDivisionModal.getIn(['isOpen'], false));
  const isFormStarted = useSelector((state) => state.routeDivisionModal.getIn(['isForm'], false));
  const splitingRoutes = useSelector((state) => state.routeDivisionModal.getIn(['splitingRoutes'], false));

  const modalTitle = getResourceTo(isFormStarted ? 'routes.label.routeDivision' : 'routes.label.transferOrderTitle');

  function getContainer() {
    let container = document
      .querySelector('.mainContainer .reactivo-tabs.gmTabs #Route #routeDivisionModalWrapper');

    if (!container) {
      container = document.createElement('div');
      container.id = 'routeDivisionModalWrapper';

      document.querySelector('.mainContainer .reactivo-tabs.gmTabs #Route').appendChild(container);
    }

    return container;
  }

  const closeModal = () => {
    const { closeModalAction } = props;

    closeModalAction();
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, closeModal]);

  return (
    <div id="routeDivisionModalWrapper">
      <Modal
        isOpen={isOpen}
        closeModalFn={identity}
        title={modalTitle}
        crossAxisBtn={false}
        className="routeDivisionModal"
        containerSelector="routeDivisionModalWrapper"
        parentSelector={() => getContainer()}
        shouldCloseOnOverlayClick
        onRequestClose={closeModal}
        footer={
          !isFormStarted ? (
            <RouteDivisionGridFooter
              splitingRoutes={splitingRoutes}
              {...props}
            />
          ) : ''
        }
      >
        {
        isFormStarted
          ? <RouteDivisionForm />
          : <RouteDivisionGrid />
        }
      </Modal>
    </div>
  );
}

RouteDivisionModal.propTypes = {
  closeModalAction: PropTypes.func.isRequired,
  openFormAction: PropTypes.func.isRequired,
  backToFormAction: PropTypes.func.isRequired,
  splitRouteAction: PropTypes.func.isRequired,
  splitRouteSuccessAction: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  closeModalAction: actionCreators.closeModal,
  openFormAction: actionCreators.openForm,
  backToFormAction: actionCreators.backToForm,
  splitRouteAction: actionCreators.splitRoute,
  splitRouteSuccessAction: actionCreators.splitRouteSuccess
};

export default connect(null, mapDispatchToProps)(RouteDivisionModal);
